import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ThumbsUp, ThumbsDown, Trash2 } from "lucide-react";

export default function AdminRatings({ api, t }) {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/ratings").then((r) => setItems(r.data)); }, [api]);

  const remove = async (r) => {
    if (!confirm(t("admin.confirmDelete"))) return;
    await api.delete(`/admin/ratings/${r.id}`);
    setItems((arr) => arr.filter((x) => x.id !== r.id));
    toast.success(t("admin.actionOk"));
  };

  if (items.length === 0) return <div className="label-tech">—</div>;

  return (
    <div className="divide-y divide-[var(--ink-200)]">
      {items.map((r) => (
        <div key={r.id} className="py-3 flex items-center gap-3" data-testid={`admin-rating-${r.id}`}>
          <div className="w-8 h-8 grid place-items-center bg-[var(--surface-alt)]">
            {r.thumbs_up ? <ThumbsUp size={14} /> : <ThumbsDown size={14} />}
          </div>
          <div className="flex-1">
            <div className="label-tech">seller {r.seller_id.slice(0,10)} · buyer {r.buyer_id.slice(0,10)}</div>
            <div className="text-xs text-[var(--ink-500)]">{new Date(r.created_at).toLocaleString()}</div>
          </div>
          <button onClick={() => remove(r)} className="btn-ghost" data-testid={`admin-delete-rating-${r.id}`}><Trash2 size={14} /></button>
        </div>
      ))}
    </div>
  );
}
